import {
  DateType,
  DynamicPropertiesFilter,
  EmcSearchOutput,
  PageInfo,
  SelectableItem,
} from './dynamic-buildings.model';
import { BuildingType, UserType } from './customer.model';

export const CUSTOMER_USER_TYPES = [
  { value: UserType.FirstCapturedUser, translation: 'COMMON.USER.TYPE.FIRST_CAPTURED' },
  { value: UserType.LastCapturedUser, translation: 'COMMON.USER.TYPE.LAST_CAPTURED' },
  { value: UserType.ReassignedBy, translation: 'COMMON.USER.TYPE.REASSIGNED' },
  { value: UserType.ValidatedBy, translation: 'COMMON.USER.TYPE.VALIDATED' },
  { value: UserType.AuditedBy, translation: 'COMMON.USER.TYPE.AUDITED' },
  { value: UserType.ReviewedBy, translation: 'INSTALLATIONS.DETAILS.REVIEWED_BY' },
];

export const CUSTOMER_VALIDATION_STATUSES = [
  { value: 0, translation: 'COMMON.ASSET_STATUS.PENDING' },
  { value: 1, translation: 'COMMON.ASSET_STATUS.COMPLETE' },
  { value: 4, translation: 'COMMON.ASSET_STATUS.REJECTED' },
  { value: 3, translation: 'COMMON.ASSET_STATUS.ASSIGNED' },
];

export const CUSTOMER_USE_OF_PREMISES = [
  { value: BuildingType.Residential, translation: 'COMMON.BUILDING_TYPE.RESIDENTIAL' },
  { value: BuildingType.Commercial, translation: 'COMMON.BUILDING_TYPE.COMMERCIAL' },
  { value: BuildingType.Industrial, translation: 'COMMON.BUILDING_TYPE.INDUSTRIAL' },
  { value: BuildingType.Mixed, translation: 'COMMON.BUILDING_TYPE.MIXED' },
  { value: BuildingType.ReligiousCenter, translation: 'COMMON.BUILDING_TYPE.RELIGIOUSHOUSE' },
];

// Property names match backend CustomersFilter; the trailing block is UI state only
export class CustomerStaticFilter {
  sortBy: number = 1;
  search: string = '';
  dateFrom: string | null = null;
  dateTo: string | null = null;
  dateType: DateType = DateType.LastUpdateTime;
  userType: number | null = null;
  tariffId: number | null = null;
  auditStatus: boolean | null = null;
  reviewStatus: boolean | null = null;
  tag: boolean | null = null;
  sltStatus: number | null = null;
  useOfPremises: number | null = null;
  selectedAreas: number[] = [];
  selectedRegions: number[] = [];
  selectedSubGeographicalRegions: number[] = [];
  selectedGeographicalRegions: number[] = [];
  selectedUsers: number[] = [];
  selectedStatuses: number[] = [];
  showDirectConnection: boolean = false;
  showAllNewEntries: boolean = false;

  dateTypeString: string = 'Last Update Time';
  regionSearchText: string = '';
  areaSearchText: string = '';
  geoSearchText: string = '';
  subGeoSearchText: string = '';
  searchUsersText: string = '';
  selectedUserTypeString: string | null = null;
  selectedRegionModel: SelectableItem | null = null;
  selectedGeoRegionModel: SelectableItem | null = null;
  selectedAreaModels: SelectableItem[] = [];
  selectedSubGeoModels: SelectableItem[] = [];
  selectedUserModels: SelectableItem[] = [];
}

export class DynamicCustomerFilter {
  pageInfo: PageInfo = new PageInfo();
  filterParams: CustomerStaticFilter = new CustomerStaticFilter();
  dynamicFilters: DynamicPropertiesFilter[] = [];
  searchObject: EmcSearchOutput = new EmcSearchOutput();
  utilityId: number = 0;
}
